const isString: Function = (value: unknown) => typeof value === 'string';

const VALIDATORS: { [key: string]: Function[] } = {
    buid: [Boolean],
    context: [Boolean],
    environment: [Boolean, isString],
    level: [Boolean, isString],
    message: [Boolean, isString],
    serviceName: [Boolean, isString],
    serviceVersion: [Boolean, isString],
    triggerType: [Boolean, isString]
};

export const validate = (requestBody: { [key: string]: unknown }) => {
    const result = Object.keys(VALIDATORS).reduce((acc: boolean[], key) => {
        VALIDATORS[key].forEach((validator: (value: unknown) => boolean) => {
            const requestValue = requestBody[key];
            acc.push(validator(requestValue));
        });

        return acc;
    }, []);

    return result.every(Boolean);
};
